import React, { useEffect, useState } from "react";
import { List as List, Table as Table } from "./list";
import Aside from "../Aside";
import SeminarFilter from "./SeminarFilter";
import Pagination from "../pagination/index";
import Queries from "../../utils/queries";
import Mapping from "../../utils/mapping";
import { useTranslation } from "react-i18next";
import heroImage from "../../assets/images/background.jpg";
import Title from "../Title";
import Error from "../Error/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGrip, faTable } from "@fortawesome/free-solid-svg-icons";
import Loading from "../Loader/index";
import useRouteLocation from "../../hooks/useRouteLocation";

function SeminarsComp() {
  const [seminars, setSeminars] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const { t } = useTranslation();
  const [showTab, setShowTab] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [filterVisible, setFilterVisible] = useState(true);

  const {
    selectedDepartement,
    setSelectedDepartement,
    selectedVille,
    setSelectedVille,
    selectedDomaine,
    setSelectedDomaine,
  } = useRouteLocation();
  const [selectedTypeFormations, setSelectedTypeFormations] = useState(null);

  function toogleShowTab() {
    setShowTab(!showTab);
  }
  function handleDepartmentChange(e) {
    if (typeof e != "string") {
      setSelectedDepartement(e.target.value);
    } else setSelectedDepartement(e);
  }

  function handleVilleChange(e) {
    console.log(typeof e);
    if (typeof e != "string") {
      setSelectedVille(e.target.value);
    } else {
      setSelectedVille(e);
    }
  }

  function handleTypeFormationsChange(e) {
    if (typeof e != "string") {
      setSelectedTypeFormations(e.target.value);
    } else setSelectedTypeFormations(e);
  }

  function handleDomaineChange(e) {
    if (typeof e != "string") {
      setSelectedDomaine(e.target.value);
    } else {
      setSelectedDomaine(e);
    }
  }

  function onPageChange(index) {
    setCurrentPage(index);
  }

  const pageLength = 12;
  const viewedSeminars = seminars.slice(
    currentPage * pageLength,
    pageLength * (currentPage + 1)
  );

  useEffect(() => {
    const visited = async () => {
      try {
        const visite = await Queries.visite("seminaireformation");
      } catch (error) {}
    };
    visited();
  });

  function toggleFilter() {
    setFilterVisible((state) => !state);
  }

  useEffect(() => {
    const seminars = async () => {
      setIsLoading(true);
      try {
        const response = await Queries.seminars(
          selectedDepartement,
          selectedVille,
          selectedDomaine,
          selectedTypeFormations
        );
        const seminarsFetched = Mapping.seminars(response.data);
        setSeminars(seminarsFetched);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        if (error.response) {
          console.log(`error.response`);
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          setError(t("error.error-request"));
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
        // console.log(error.toJSON());
      }
    };
    seminars();
  }, [
    selectedDepartement,
    selectedVille,
    selectedDomaine,
    selectedTypeFormations,
  ]);

  const content = error ? (
    <Error
      titre="Echec de chargement des donnees"
      indication="Nous rencontrons actuellement un problème lors du chargement des données. Veuillez réessayer plus tard."
    />
  ) : (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-4">
        <div className="pt-8 pl-10 pr-4">
          {showTab && (
            <button
              aria-hidden={true}
              tabIndex={-1}
              className="ml-4 mb-4"
              onClick={toogleShowTab}
            >
              <FontAwesomeIcon icon={faTable} style={{ color: "brown" }} />{" "}
            </button>
          )}
          {!showTab && (
            <button
              aria-hidden={true}
              tabIndex={-1}
              className="ml-4 mb-4"
              onClick={toogleShowTab}
            >
              <FontAwesomeIcon icon={faGrip} style={{ color: "brown" }} />{" "}
            </button>
          )}

          <SeminarFilter
            onDepartementChange={handleDepartmentChange}
            onVilleChange={handleVilleChange}
            onTypeFormationsChange={handleTypeFormationsChange}
            onDomaineChange={handleDomaineChange}
            selectedDomaine={selectedDomaine}
            selectedVille={selectedVille}
            selectedDepartement={selectedDepartement}
            selectedTypeFormations={selectedTypeFormations}
            isVisible={filterVisible}
          />
        </div>
        <div className="col-span-3 pr-10 pl-4">
          <Title name="Liste des séminaires et formations" />

          {showTab && (
            <List toggleFilter={toggleFilter} seminars={viewedSeminars} />
          )}
          {!showTab && (
            <Table toggleFilter={toggleFilter} seminars={viewedSeminars} />
          )}
          <br />
          <Pagination
            currentPage={currentPage}
            onPathClick={onPageChange}
            totalPage={Math.ceil(seminars.length / pageLength)}
          />
        </div>
      </div>
    </>
  );

  return (
    <main className="min-h-screen bg-gray-50">
      <div
        className="bg-cover bg-center bg-no-repeat w-full  bg-white-500"
        style={{
          backgroundImage: `url(${heroImage})`,
          backgroundSize: "cover",
          overflow: "hidden",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          backgroundBlendMode: "multiply",
        }}
      >
        <h1 className="text-yellow-800 text-4xl font-bold text-center h-full bg-gray-50/50 pt-8 pb-8">
          {t("page.seminar.title")}
        </h1>
      </div>

      <div className="max-w-full pl-1 lg:pl-4 pr-1 lg:pr-4 grid grid-rows-1 lg:grid-cols-5 gap-4 md:grid-cols-5">
        <div className="col-span-5 md:col-span-5 md:p-4">
          {isLoading ? <Loading /> : content}
        </div>
      </div>
    </main>
  );
}

export default SeminarsComp;
